import React, { useState, useEffect } from 'react'
import { Dropdown, Button, ListGroup, Card } from 'react-bootstrap'
import { Link, useNavigate } from 'react-router-dom'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { Trans } from 'react-i18next'
import { formatDistance } from 'date-fns'
import it from 'date-fns/locale/it'
import { getMessages, markMessages, scrollToMessage } from 'src/store/messages'

const delay = ms => new Promise(resolve => setTimeout(resolve, ms))
const Notification = ({ messages, has_new_messages, dispatch, router }) => {
  const [showDropdown, setShowDropdown] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    const fetchMessages = async () => {
      if (router.location.pathname === '/messages') return
      await delay(1000)
      await dispatch(getMessages({ offset: 0, limit: 20 }))
    }

    fetchMessages()

    const interval = setInterval(fetchMessages, 60000)

    return () => clearInterval(interval)
  }, [dispatch, router.location.pathname])

  const handleMarkMessage = async () => {
    dispatch(markMessages({ message_id: null, mark: true, all: true }))
    await dispatch(getMessages({ offset: 0, limit: 20 }))
  }

  const handleClickMessage = messageId => {
    dispatch(scrollToMessage(messageId))
    navigate('/messages')
    setShowDropdown(false)
  }
  return (
    <Dropdown
      show={showDropdown}
      onToggle={() => setShowDropdown(prev => !prev)}
      align="end"
      className="d-flex align-items-center">
      <Dropdown.Toggle as={Link} variant="link" to="#" id="dropdown-basic">
        <i className="feather icon-bell icon" />
        {has_new_messages > 0 && (
          <span className="badge bg-danger" style={{ position: 'absolute', right: '26px', top: '12px' }}>
            {has_new_messages}
          </span>
        )}
      </Dropdown.Toggle>
      <Dropdown.Menu align="end" className="notification notification-scroll">
        <div className="noti-head">
          <h6 className="d-inline-block m-b-0">
            <Trans i18nKey="system_wide.navbar.message_board">Bacheca</Trans>
          </h6>
          {has_new_messages > 0 && (
            <div className="float-end d-flex">
              <Button variant="link" className="me-2 text-decoration-underline" onClick={handleMarkMessage}>
                <Trans i18nKey="system_wide.navbar.mark_as_read">Segna come letto</Trans>
              </Button>
            </div>
          )}
        </div>
        <PerfectScrollbar>
          <ListGroup as="ul" bsPrefix=" " variant="flush" className="noti-body">
            {messages.length === 0 && (
              <ListGroup.Item as="li" bsPrefix=" " className="n-title">
                <p className="m-b-0">
                  <Trans i18nKey="system_wide.navbar.no_messages">Non ci sono nuovi messaggi</Trans>
                </p>
              </ListGroup.Item>
            )}
            {has_new_messages > 0 && (
              <ListGroup.Item as="li" bsPrefix=" " className="n-title">
                <p className="m-b-0">
                  <Trans i18nKey="system_wide.navbar.new">Nuove</Trans>
                </p>
              </ListGroup.Item>
            )}
            {messages
              .filter(m => m.read_at === null)
              .map((m, i) => {
                let full_name = m.created_by.first_name + ' ' + m.created_by.last_name
                let now = new Date()
                let duration = formatDistance(m.created_at, now, { locale: it })
                let avatar_link = `https://ui-avatars.com/api/?name=${full_name}&background=0D8ABC&color=fff`
                return (
                  <ListGroup.Item
                    key={i}
                    as="li"
                    role="button"
                    bsPrefix=" "
                    className="notification"
                    onClick={() => handleClickMessage(m.id)}>
                    <Card
                      className="d-flex align-items-center shadow-none mb-0 p-0"
                      style={{ flexDirection: 'row', backgroundColor: 'unset' }}>
                      <img className="img-radius" src={avatar_link} alt="Generic placeholder" />
                      <Card.Body className="p-0">
                        <p>
                          <strong>{full_name}</strong>
                          <span className="n-time text-muted">
                            <i className="icon feather icon-clock me-2" />
                            {duration}
                          </span>
                        </p>
                        <p className="truncate small">{m.title}</p>
                      </Card.Body>
                    </Card>
                  </ListGroup.Item>
                )
              })}
            {messages.length > 0 && (
              <ListGroup.Item as="li" bsPrefix=" " className="n-title">
                <p className="m-b-0">
                  <Trans i18nKey="system_wide.navbar.old">Già lette</Trans>
                </p>
              </ListGroup.Item>
            )}
            {messages
              .filter(m => m.read_at !== null)
              .map((m, i) => {
                let full_name = m.created_by.first_name + ' ' + m.created_by.last_name
                let now = new Date()
                let duration = formatDistance(m.created_at, now, { locale: it })
                let avatar_link = `https://ui-avatars.com/api/?name=${full_name}&background=0D8ABC&color=fff`
                return (
                  <ListGroup.Item
                    key={i}
                    as="li"
                    bsPrefix=" "
                    className="notification"
                    role="button"
                    onClick={() => handleClickMessage(m.id)}>
                    <Card
                      className="d-flex align-items-center shadow-none mb-0 p-0"
                      style={{ flexDirection: 'row', backgroundColor: 'unset' }}>
                      <img className="img-radius" src={avatar_link} alt="Generic placeholder" />
                      <Card.Body className="p-0">
                        <p>
                          <strong>{full_name}</strong>
                          <span className="n-time text-muted">
                            <i className="icon feather icon-clock me-2" />
                            {duration}
                          </span>
                        </p>
                        <p className="truncate small">{m.title}</p>
                      </Card.Body>
                    </Card>
                  </ListGroup.Item>
                )
              })}
          </ListGroup>
        </PerfectScrollbar>
        <div className="noti-footer">
          <Link to="/messages">
            <Trans i18nKey="system_wide.navbar.view_all">Visualizza tutto</Trans>
          </Link>
        </div>
      </Dropdown.Menu>
    </Dropdown>
  )
}
export default Notification
